import { Injector } from '@angular/core';
import { TableDataSource } from '@shared/table/table.datasource';
import { finalize } from 'rxjs/operators';

export class AccountNotesDatasource extends TableDataSource {
  private accountId: string;

  constructor(injector: Injector, accountId: string) {
    super(injector);
    this.accountId = accountId;
  }

  loadData(params: any): void {
    this.onLoadDataStart();
    this.api.accounts.byId.notes
      .get(this.accountId, params)
      .pipe(
        finalize(() => {
          this.onLoadDataEnd();
        })
      )
      .subscribe((data) => {
        this.paginatedGet.next(data);
      });
  }
}
